export const servicesCategoryMap = {
    "Acupuncture": "acupuncture",
    // eslint-disable-next-line no-dupe-keys
    "Acupuncture": "acupuncturetreat",
    "Couples Treatments ": "couplestreatments",
    " Detox Wraps / Body Therapies": "detoxbodytherapies",
    "Facial Treatments": "facialtreatments",
    "Fitness Program": "fitnessprogram",
    "Hair Services": "hairservices",
    "Make Up": "makeup",
    " Massage Therapies": "massagetherapies",
    "Medi-Spa Cosmetic Treatments": "medispacosmetic",
    "Men's Services": "mensservices",
    "Nail Services": "nailservices",
    "Relaxation Areas": "relaxationareas",
    "Tooth Whitening": "teethwhitening",
    "YSPA Services for Teens": "zspaforteens",
    "Body Services": "body"
}

export const categoryImageMap = {
    'acupuncturetreat': 'Acupuncture_Treatments.jpg',
    'acupuncture': 'Acupuncture_Treatments.jpg',
    'couplestreatments': 'Couples_Treatments.jpg',
    'detoxbodytherapies': 'Detox_and_Body_Therapies.jpg',
    'facialtreatments': 'Facial_Treatments.jpg',
    'fitnessprogram': 'Fitness_Program.jpg',
    'hairservices': 'Hair_Services.jpg',
    'massagetherapies': 'Massage_Therapies.jpg',
    'medispacosmetic': 'Medi-Spa_Cosmetic_Treatments.jpg',
    'mensservices': 'Mens_Services.jpg',
    'nailservices': 'Nail_Services.jpg',
    'relaxationareas': 'Relaxation_Areas.jpg',
    'teethwhitening': 'Tooth_Whitening.jpg',
    'zspaforteens': 'ZSPA_Services_for_Teens.jpg'
}


